const initState = {
    user: null,
    siteFontSize: 14,
    isDarkMode: JSON.parse(localStorage.getItem('darkMode') || 'false')
};

export default function reducer(
    state = initState,
    { type, payload }
) {
    switch (type) {
        case 'SET_USER':
            return {
                ...state,
                user: payload
            }
        case 'SET_SITE_FONT_SIZE':
            return {
                ...state,
                siteFontSize: payload
            }
        case 'SET_DARK_MODE':
            return {
                ...state,
                isDarkMode: payload
            }
    }

    return state;
}